module.exports = __webpack_public_path__ + "assets/img/replace-product-switch-horizontal.9c067aea.svg";